export default "__VITE_ASSET__DYVFK0vS__"